import cx from "classnames";
import type { ReactNode } from "react";
import styles from "./Section.module.scss";

type SectionProps = {
  id?: string;
  children: ReactNode;
  className?: string;
  deep?: boolean;
};

export const Section = ({
  id,
  children,
  className,
  deep = false,
}: SectionProps) => (
  <section
    id={id}
    className={cx(styles.section, {
      [styles.deep]: deep,
    }, className)}
  >
    {children}
  </section>
);
